import React from 'react'

import Icon from 'components/Icon'
import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Tag from 'components/Tag'
import Typography from 'components/Typography'

import classes from './Heading.module.scss'

/** @type {import("./types").default} */
const Heading = ({ hasFreeTrial }) => (
  <div className={classes.root}>
    <Typography variant="heading-xs" className={classes.startingPrice} component={'span'}>
      Starting price
      <InfoCircleTooltip
        title="Prices may vary depending on the number of users and features."
        enterTouchDelay={100}
        leaveTouchDelay={3000}
      />
    </Typography>
    <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
      Free trial
      <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
    </Tag>
  </div>
)

export default Heading
